import {
  loadSopPaymentRequest,
  loadSopPaymentResponse,
  removePaymentDetails,
  loadPaymentDetailsList,
  updatePaymentDetails
} from './actions';
import { UsePaymentFactoryParams } from '../factories/usePaymentFactory';

export const params: UsePaymentFactoryParams = {
  loadSopPaymentResponse,
  loadSopPaymentRequest,
  removePaymentDetails,
  loadPaymentDetailsList,
  updatePaymentDetails
};
